import React, { useEffect, useState } from 'react';
import PreferencesPanel from './PreferencesPanel';
import { fetchMyPreferences, updateMyPreferences } from './emailPreferencesApi';
import styles from './Email.module.css';

// Email notification preferences for the signed-in user (Dashboard → Profile).
const ProfileEmailPreferences = ({ isDark = false }) => {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    const token = localStorage?.getItem('token');
    if (!token) return undefined;
    (async () => {
      const res = await fetchMyPreferences(token);
      if (!alive) return;
      if (res.ok) setInfo(res.data);
      else setError(res.error);
    })();
    return () => { alive = false; };
  }, []);

  const save = async (categories) => {
    const res = await updateMyPreferences(localStorage?.getItem('token'), { categories });
    if (res.ok) setInfo(res.data);
    return res;
  };

  return (
    <div className={`${styles.profileSection} ${isDark ? styles.profileSectionDark : ''}`}>
      {error && <p className={styles.error} role="alert">{error}</p>}
      {!info && !error && <div className={styles.loader} role="status">Loading email preferences…</div>}
      {info && (
        <>
          {info.suppressed && (
            <p className={styles.error} role="alert">
              Emails to your address are paused because earlier messages could not be delivered. Contact support to turn them back on.
            </p>
          )}
          <PreferencesPanel
            idPrefix="profile-email-pref"
            categoryMeta={info.categoryMeta}
            categories={info.categories}
            canIncrease
            onSave={save}
            dark={isDark}
          />
        </>
      )}
    </div>
  );
};

export default ProfileEmailPreferences;
